import md5 from 'md5'
// import md5 from '../assets/js/md5'
import Vue from 'vue'

//创建请求随机字符串:uuid + timestamp
function createNonceStr(timestamp) {
  function S4() {
    return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1)
  }

  var nonce = S4() + S4() + S4() + S4() + S4() + S4() + S4() + S4()
  return md5(nonce + timestamp)
}

//创建时间戳
function createTimeStamp() {
  return new Date().getTime()
}

//签名函数
function sign(timestamp, nonce, params) {
  var signParams = {}
  if (params != null) {
    for (let key in params) {
      //文件类型不参与签名
      if (!(params[key] instanceof File)) {
        signParams[key] = params[key]
      }
    }
  }
  signParams['timestamp'] = timestamp
  signParams['nonce'] = nonce
  //console.log(signParams);
  var sortedKeys = Object.keys(signParams).sort()
  var sortedParams = {}
  for (var i = 0; i < sortedKeys.length; i++) {
    sortedParams[sortedKeys[i]] = signParams[sortedKeys[i]]
  }
  //console.log(sortedParams);
  var codes = ''
  codes = globalConfig.appId
  for (let key in sortedParams) {
    codes += key + sortedParams[key]
  }
  codes += globalConfig.appSecret

  return md5(codes)
}

const user = {
  //获取请求头
  createHeaders(params) {
    let headers = {}
    let token = Vue.ls.get('token')
    //教育局ID
    // console.log('Vue.ls.get(\'bureauId\')', Vue.ls.get('bureauId'))
    let bureauId = Vue.ls.get('bureauId')
    if (token) {
      headers['Authorization'] = token
    }
    if (bureauId) {
      headers['bureauId'] = bureauId
    }
    headers['Cache-Control'] = 'no-cache'
    headers['Pragma'] = 'no-cache'
    // headers['timestamp'] = createTimeStamp()
    // headers['nonce'] = createNonceStr(headers['timestamp'])
    // headers['sign'] = sign(headers['timestamp'], headers['nonce'], params)
    return headers
  },
}

export default user
